import { canAccessAgentChatSelector } from '@lumapps/agent-chat-global/ducks/selectors';
import { get as getConstants } from '@lumapps/constants';
import { doesCurrentUserHaveAccessToCustomContentTypes } from '@lumapps/content-types/ducks/selectors';
import { isNewWriterEditorEnabled } from '@lumapps/contents/ducks/selectors';
import { isFeatureEnabled } from '@lumapps/features';
import { isInstanceSuperAdmin } from '@lumapps/permissions';
import { createSelector } from '@lumapps/redux/reselect';

import { PAGE_WRITER_AGENT_FF } from '../constants';

const constants = getConstants();

/**
 * Selector to check whether the Page Writer Agent features should be enabled.
 * Gated by the global agent chat access and the dedicated `page-writer-agent` flag, plus the
 * `accessible-writer-editor` flag. The user must also have access to custom content types (or be
 * an instance super admin). Disabled on legacy pages where the Page Writer Agent is not functional.
 *
 * The agent-chat rollout gate lives entirely inside `canAccessAgentChatSelector`, so this selector
 * is unaffected by the early-access → GA promotion in #16830.
 */
export const isPageWriterAgentEnabled = createSelector(
    canAccessAgentChatSelector,
    isFeatureEnabled(PAGE_WRITER_AGENT_FF),
    isNewWriterEditorEnabled,
    doesCurrentUserHaveAccessToCustomContentTypes,
    isInstanceSuperAdmin,
    (canAccessAgentChat, isPageWriterFlagEnabled, isNewWriterEditorAllowed, hasAccessToCCT, isSuperAdmin) =>
        !constants.isLegacyContext &&
        canAccessAgentChat &&
        isPageWriterFlagEnabled &&
        isNewWriterEditorAllowed &&
        (hasAccessToCCT || isSuperAdmin),
);
